module.exports = __webpack_public_path__ + "img/app_dest.87021b03.png";